import React from "react";
import { Control } from "react-hook-form";
import { ReactSelectField } from "../../atoms/FormElement";
import { getValidationProps } from "../../libs/form";

interface OwnerUserLinkingProps {
  control: Control<any>;
  userOptions: { label: string; value: string }[];
  setAssignedUser: (any) => void;
  assignedUser?: Object;
  setValue?: any;
}

const OwnerUserLinking: React.FC<OwnerUserLinkingProps> = ({
  control,
  userOptions,
  setAssignedUser,
  assignedUser,
  setValue,
}) => {
  const defaultProps = { control };

  return (
    <div style={{ position: "relative", top: "12px", width: "343px" }}>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div style={{ marginTop: "5px", fontSize: "16px", color: "#000" }}>
          <span>Assigned To:</span>
        </div>
        <div style={{ width: "250px" }}>
          <ReactSelectField
            fieldname="assignedUser"
            //   label="User"
            initialValue={assignedUser}
            selectOption={userOptions}
            {...defaultProps}
            {...getValidationProps({
              fieldName: "assignedUser",
            })}
            iProps={{ placeholder: "Select user" }}
            onChange={(value) => {
              setAssignedUser(value);
            }}
            setValue={setValue}
            valueGot={assignedUser}
          />
        </div>
      </div>
    </div>
  );
};

export default OwnerUserLinking;
